import React, { useEffect, useState } from 'react';

import { v4 as uuidv4 } from 'uuid';
import Notification from '@tds/core-notification';
import Button from '@tds/core-button';

import QuantityField from './quantityField';
import Question from './question';

import {
  ServiceWrapper,
  Table,
  Thead,
  Th,
  Tr,
  Td,
  ButtonLink,
  GroupOverlay,
  GroupOverlayInner,
  Title,
  ButtonWrapper,
  ButtonLinkDelete
} from './css';
import AddSVG from '../assets/svg/add';
import ServiceLabel from './serviceLabel';
import DeleteSVG from '../assets/svg/delete';
import { deleteService } from './saveSchemaToDB';

export default function Service({
  serviceData,
  offeringId,
  groupIndex,
  serviceIndex,
  setSavingData,
  fullyManagedAdminData,
  setFullyManagedAdminData
}) {
  const {
    name: serviceLabel,
    productCatalogQuantities,
    quantityLabel,
    isSaved,
    productCatalogQuestions: serviceQuestions
  } = serviceData;
  const [showOverlay, setShowOverlay] = useState(false);
  let serviceId =
    fullyManagedAdminData[groupIndex].ServicesInGroup[serviceIndex].id;

  const canDeleteService =
    fullyManagedAdminData[groupIndex].ServicesInGroup.length > 1;
  const handleAddQuestion = () => {
    const clonedAdminData = JSON.parse(JSON.stringify(fullyManagedAdminData));
    clonedAdminData[groupIndex].ServicesInGroup[
      serviceIndex
    ].productCatalogQuestions.push({
      serviceId: serviceData.id || '',
      offeringId,
      id: '', // questionId
      name: '',
      isSaved: false,
      isRequired: false,
      productCatalogOptions: [
        {
          questionId: '',
          id: '',
          name: '',
          productCatalogPricings: [
            {
              id: '',
              optionId: '',
              cost: 0,
              onetimePrice: 0,
              costPremium: 0,
              onetimePricePremium: 0,
              operationType: 'ADD'
            }
          ]
        }
      ]
    });
    setFullyManagedAdminData(clonedAdminData);
  };

  const handleDeleteService = async () => {
    const clonedAdminData = JSON.parse(JSON.stringify(fullyManagedAdminData));
    if (serviceId) {
      await deleteService(serviceId);
    }
    clonedAdminData[groupIndex].ServicesInGroup.splice(serviceIndex, 1);
    setFullyManagedAdminData(clonedAdminData);
  };

  return (
    <ServiceWrapper>
      {showOverlay && (
        <GroupOverlay>
          <GroupOverlayInner>
            <Title>Are you sure you want to proceed?</Title>
            <ButtonWrapper>
              <Button variant="secondary" onClick={() => setShowOverlay(false)}>
                Cancel
              </Button>
              <Button onClick={handleDeleteService}>Delete</Button>
            </ButtonWrapper>
          </GroupOverlayInner>
        </GroupOverlay>
      )}
      <Table>
        <Thead>
          <Th width="40%">
            <ServiceLabel
              serviceLabel={serviceLabel}
              offeringId={offeringId}
              groupIndex={groupIndex}
              serviceIndex={serviceIndex}
              setSavingData={setSavingData}
              fullyManagedAdminData={fullyManagedAdminData}
              setFullyManagedAdminData={setFullyManagedAdminData}
            />
          </Th>
          <Th width="40%"></Th>
          <Th width="10%">Cost</Th>
          <Th width="10%">Price</Th>
        </Thead>
        <tbody>
          {serviceId && (
            <QuantityField
              serviceId={serviceId}
              quantityData={productCatalogQuantities}
              groupIndex={groupIndex}
              serviceIndex={serviceIndex}
              setSavingData={setSavingData}
              fullyManagedAdminData={fullyManagedAdminData}
              setFullyManagedAdminData={setFullyManagedAdminData}
            />
          )}
          {serviceId &&
            serviceQuestions.map((questionData, index) => (
              <Question
                questionData={questionData}
                groupIndex={groupIndex}
                serviceIndex={serviceIndex}
                questionIndex={index}
                setSavingData={setSavingData}
                fullyManagedAdminData={fullyManagedAdminData}
                setFullyManagedAdminData={setFullyManagedAdminData}
                isLast = {serviceQuestions.length ===1}
              />
            ))}
          <Tr>
            {serviceId && (
              <Td>
                <ButtonLink onClick={handleAddQuestion}>
                  <AddSVG size={18} />
                  Add question
                </ButtonLink>
              </Td>
            )}
            <Td></Td>
          </Tr>
        </tbody>
      </Table>
      {canDeleteService && (
        <ButtonLinkDelete onClick={() => setShowOverlay(true)}>
          <DeleteSVG size="19" color="#c12335" />
          Delete Service
        </ButtonLinkDelete>
      )}
      {!serviceId && (
        <Notification variant="warning" copy="en">
          <p>
            Note: The service should not be saved without adding at least one
            question.
          </p>
        </Notification>
      )}
    </ServiceWrapper>
  );
}
